import { render } from "./CategoryDropdown.vue?vue&type=template&id=2d9c08e4&ts=true"
import script from "./CategoryDropdown.vue?vue&type=script&lang=ts"
export * from "./CategoryDropdown.vue?vue&type=script&lang=ts"

import "./CategoryDropdown.vue?vue&type=style&index=0&id=2d9c08e4&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__